import { defineComponent as w, inject as g, computed as l, useSlots as L, useAttrs as P, createBlock as n, openBlock as a, unref as s, mergeProps as V, withCtx as u, createCommentVNode as c, normalizeClass as h, renderSlot as d } from "vue";
import { fallbackCommonSize as j, fallbackBasicColor as A } from "./highrise68.mjs";
import { JSONtoNaiveVars as z } from "./highrise343.mjs";
import p from "./highrise125.mjs";
import "./highrise59.mjs";
import { createButtonVariantStyle as W } from "./highrise438.mjs";
import { getButtonSizeStyles as R, getIconOnlyButtonPaddings as E, getLinkButtonSize as M } from "./highrise439.mjs";
import { fallbackVariant as B } from "./highrise440.mjs";
import { COMPONENT_NAME as F } from "./highrise178.mjs";
import G from "./highrise441.mjs";
import H from "./highrise84.mjs";
const I = w({
  name: F.BUTTON,
  inheritAttrs: !0
}), ot = /* @__PURE__ */ w({
  ...I,
  props: {
    id: {},
    size: {},
    color: { default: "gray" },
    variant: { default: "secondary" },
    disabled: { type: Boolean, default: void 0 },
    loading: { type: Boolean, default: void 0 },
    link: { type: Boolean, default: void 0 },
    href: {},
    target: {},
    fullWidth: { type: Boolean }
  },
  emits: ["click"],
  setup(_) {
    const e = _, v = g("hr-form", null), O = g("hr-input-group-size", v), C = g("hr-section-footer-size", null), b = l(() => e.size || C || O || v || "sm"), o = L(), y = P(), S = l(() => ({
      color: A(e.color),
      size: j(b.value),
      variant: B(e.variant)
    })), r = l(() => {
      const { size: t, variant: i, color: f } = S.value, T = R(t), x = W(f, i);
      let m = {
        ...z(T),
        ...z(x)
      };
      return i === "text" && Object.assign(m, z(M())), o.icon && !o.default && Object.assign(m, E(t)), m;
    }), $ = Object.keys(y).reduce(
      (t, i) => ((i === "class" || i.startsWith("data-") || i.startsWith("aria-")) && (t[i] = y[i]), t),
      {}
    ), N = l(() => ({
      [`hr-button--${B(e.variant)}`]: !0,
      "hr-button--link": e.link || e.href,
      "hr-button--icon-only": (o.iconLeft || o.iconRight) && !o.default,
      [`hr-button--${b.value}`]: !0,
      "hr-button--full-width": e.fullWidth
    })), k = l(() => ({
      lg: {
        size: "2xl",
        weight: "semibold"
      },
      md: {
        size: "lg",
        weight: "semibold"
      },
      sm: {
        size: "lg",
        weight: "semibold"
      },
      xs: {
        size: "md",
        weight: "semibold"
      },
      "2xs": {
        size: "sm",
        weight: "semibold"
      },
      "3xs": {
        size: "xs",
        weight: "semibold"
      }
    })[S.value.size]);
    return (t, i) => (a(), n(s(G), V({
      id: t.id,
      disabled: e.disabled,
      loading: e.loading,
      style: r.value,
      class: N.value,
      tag: e.href ? "a" : "button",
      href: e.href,
      target: e.target
    }, { ...s($) }, {
      onClick: i[0] || (i[0] = (f) => t.$emit("click", f))
    }), {
      default: u(() => [
        s(o).icon && !s(o).default ? (a(), n(p, {
          key: 0,
          size: r.value["--n-icon-size"],
          color: r.value["--n-icon-color"],
          class: h("hr-icon")
        }, {
          default: u(() => [
            d(t.$slots, "icon", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["size", "color"])) : c("", !0),
        s(o).iconLeft ? (a(), n(p, {
          key: 1,
          size: r.value["--n-icon-size"],
          color: r.value["--n-icon-color"],
          class: h("hr-icon-left")
        }, {
          default: u(() => [
            d(t.$slots, "iconLeft", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["size", "color"])) : c("", !0),
        s(o).default && !s(o).icon ? (a(), n(s(H), {
          key: 2,
          class: "hr-button__content-default-slot",
          size: k.value.size,
          weight: k.value.weight
        }, {
          default: u(() => [
            d(t.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["size", "weight"])) : c("", !0),
        s(o).iconRight ? (a(), n(p, {
          key: 3,
          size: r.value["--n-icon-size"],
          color: r.value["--n-icon-color"],
          class: h("hr-icon-right")
        }, {
          default: u(() => [
            d(t.$slots, "iconRight", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["size", "color"])) : c("", !0)
      ]),
      _: 3
    }, 16, ["id", "disabled", "loading", "style", "class", "tag", "href", "target"]));
  }
});
export {
  ot as default
};
